export const extractProprietorName = (inputString) => {
  if (!inputString || typeof inputString !== 'string') {
    return '';
  }

  let cleanedName = inputString.trim();

  // Remove leading pattern like "(1) ", "(2) ", etc.
  cleanedName = cleanedName.replace(/^\(\d+\)\s*/, '');

  // Remove newline characters and everything after them
  cleanedName = cleanedName.split('\n')[0].trim();

  // Remove anything within square brackets including the brackets
  cleanedName = cleanedName.replace(/\[.*?\]/g, '');

  // Remove honorifics like MR., MRS., MS., DR., etc.
  cleanedName = cleanedName.replace(/^\b(MR\.?|MRS\.?|MS\.?|DR\.?|MISS\.?)\s+/i, '');

  // Remove M/S, M/S., or similar prefixes
  cleanedName = cleanedName.replace(/^\b(M\/S\.?|M\/s\.?)\s+/i, '');

  // Define suffixes/patterns to remove (case insensitive)
  const suffixesToRemove = [
    'Body Incorporate', 'Single Firm', 'Partnership Firm', 'Proprietorship',
    'Sole Proprietorship', 'Private Limited', 'Public Limited', 'Limited Liability Partnership',
    'LLP', 'PRIVATE LIMITED', 'PVT LTD', 'PVT. LTD.', 'PRIVATE LTD', 'LIMITED',
    'LTD', 'INC', 'INCORPORATED', 'CORP', 'CORPORATION', 'LLC', 'CO.',
    'COMPANY', 'Partnership Firm Details', 'Firm Details', 'Details'
  ];

  // Remove "Details : " and everything after it
  cleanedName = cleanedName.replace(/Details\s*:\s*.*$/i, '');
  cleanedName = cleanedName.replace(/Firm\s+Details\s*:\s*.*$/i, '');
  cleanedName = cleanedName.replace(/Partnership\s+Firm\s+Details\s*:\s*.*$/i, '');

  // Create regex pattern for suffixes (handle both spaced and concatenated cases)
  const suffixPattern = suffixesToRemove
    .map(suffix => suffix.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
    .join('|');

  // First try with word boundaries (for properly spaced suffixes)
  const suffixRegexWithBoundary = new RegExp(`\\b(${suffixPattern})\\b`, 'gi');
  cleanedName = cleanedName.replace(suffixRegexWithBoundary, '');

  // Then try without word boundaries (for concatenated suffixes like "KUMARSingle Firm")
  const suffixRegexNoBoundary = new RegExp(`(${suffixPattern})`, 'gi');
  cleanedName = cleanedName.replace(suffixRegexNoBoundary, '');

  // Handle "/" separator cases
  if (cleanedName.includes('/')) {
    const parts = cleanedName.split('/').map(part => part.trim());
    const businessWords = /\b(CO|COMPANY|CORP|ENTERPRISES|SERVICES|SOLUTIONS|SYSTEMS|TECH|INDUSTRIES|GROUP)\b/i;
    cleanedName = parts.reduce((best, current) => {
      if (businessWords.test(current)) return current;
      if (businessWords.test(best)) return best;
      return current.length > best.length ? current : best;
    });
  }

  // Clean up whitespace and punctuation
  cleanedName = cleanedName
    .replace(/\s+/g, ' ')
    .replace(/[,.-]+$/, '')
    .replace(/^[,.-]+/, '')
    .trim();

  return cleanedName || inputString.replace(/^\(\d+\)\s*/, '').trim();
};